export default __webpack_public_path__ + "static/media/service1.114615f5.png";